import { useEffect, useCallback, useContext } from 'react';

import { ExperienceTrackerContext } from '@confluence/experience-tracker';

import {
	loadPanelSubExperiences,
	abortAllLoadPanelExperiencesOnEditPageEnded,
	abortAllLoadPanelExperiences,
} from './experienceTrackerHelpers';

type UseTemplatePanelExperienceTrackerResponse = {
	abortTemplatePanelLoadExperiences: (reason: string) => void;
};

export const useLoadTemplatePanelExperienceTracker =
	(): UseTemplatePanelExperienceTrackerResponse => {
		const experienceTracker = useContext(ExperienceTrackerContext);

		useEffect(() => {
			return experienceTracker.subscribe(
				abortAllLoadPanelExperiencesOnEditPageEnded(experienceTracker, loadPanelSubExperiences),
			);
		}, [experienceTracker]);

		const abortExperiences = useCallback(
			(reason: any) => {
				abortAllLoadPanelExperiences(experienceTracker, loadPanelSubExperiences, reason);
			},
			[experienceTracker],
		);

		return {
			abortTemplatePanelLoadExperiences: abortExperiences,
		};
	};
